"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerTrack = void 0;

require("core-js/modules/es.array.concat.js");

var _booleanPointInPolygon = _interopRequireDefault(require("@turf/boolean-point-in-polygon"));

var _lineToPolygon = _interopRequireDefault(require("@turf/line-to-polygon"));

var _pointToLineDistance = _interopRequireDefault(require("@turf/point-to-line-distance"));

var _speaker_player = require("./speaker_player");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var convertLinesToPolygon = function convertLinesToPolygon(shape) {
  return (// @ts-ignore
    (0, _lineToPolygon.default)(shape)
  );
};

var FADE_DURATION_SECONDS = 3;
var NEARLY_ZERO = 0.05;
/** A Roundware speaker under the control of the client-side mixer, representing 'A polygonal geographic zone within which an ambient audio stream broadcasts continuously to listeners.
 * Speakers can overlap, causing their audio to be mixed together accordingly.  Volume attenuation happens linearly over a specified distance from the edge of the Speaker’s defined zone.'
 * (quoted from https://github.com/loafofpiecrust/roundware-ios-framework-v2/blob/client-mixing/RWFramework/RWFramework/Playlist/Speaker.swift)
 * */

var SpeakerTrack = /*#__PURE__*/function () {
  function SpeakerTrack(_ref) {
    var _this = this;

    var audioContext = _ref.audioContext,
        listenerPoint = _ref.listenerPoint,
        prefetchAudio = _ref.prefetchAudio,
        data = _ref.data;

    _classCallCheck(this, SpeakerTrack);

    var speakerId = data.id,
        maxVolume = data.maxvolume,
        minVolume = data.minvolume,
        attenuation_border = data.attenuation_border,
        boundary = data.boundary,
        attenuationDistance = data.attenuation_distance,
        uri = data.uri;
    this.prefetch = prefetchAudio;
    this.speakerData = data;
    this.speakerId = speakerId;
    this.maxVolume = maxVolume;
    this.minVolume = minVolume;
    this.attenuationDistanceKm = attenuationDistance / 1000;
    this.uri = uri;
    this.player = new _speaker_player.SpeakerPlayer(audioContext, speakerId, uri);
    this.player.audio.addEventListener("playing", function () {
      return _this.updateVolume();
    });
    this.listenerPoint = listenerPoint.geometry;
    this.attenuationBorderPolygon = convertLinesToPolygon(attenuation_border);
    this.attenuationBorderLineString = attenuation_border;
    this.outerBoundary = convertLinesToPolygon(boundary);
    this.currentVolume = NEARLY_ZERO;
  }

  _createClass(SpeakerTrack, [{
    key: "outerBoundaryContains",
    value: function outerBoundaryContains(point) {
      return (0, _booleanPointInPolygon.default)(point, this.outerBoundary);
    }
  }, {
    key: "attenuationShapeContains",
    value: function attenuationShapeContains(point) {
      return (0, _booleanPointInPolygon.default)(point, this.attenuationBorderPolygon);
    }
  }, {
    key: "attenuationRatio",
    value: function attenuationRatio(atPoint) {
      var distToInnerShapeKm = (0, _pointToLineDistance.default)(atPoint, this.attenuationBorderLineString, {
        units: "kilometers"
      });
      var ratio = 1 - distToInnerShapeKm / this.attenuationDistanceKm;
      return ratio;
    }
  }, {
    key: "calculateVolume",
    value: function calculateVolume() {
      var listenerPoint = this.listenerPoint;
      var newVolume = this.currentVolume;

      if (!listenerPoint) {
        newVolume = this.currentVolume;
      } else if (this.attenuationShapeContains(listenerPoint)) {
        newVolume = this.maxVolume;
      } else if (this.outerBoundaryContains(listenerPoint)) {
        var range = this.maxVolume - this.minVolume;
        var volumeGradient = this.minVolume + range * this.attenuationRatio(listenerPoint);
        newVolume = volumeGradient;
      } else {
        newVolume = this.minVolume;
      } // don't exceed values over 1.0


      if (newVolume > 1) newVolume = 1;
      return newVolume;
    }
  }, {
    key: "updateParams",
    value: function updateParams(isPlaying, opts) {
      if (opts && opts.listenerPoint && opts.listenerPoint.geometry) {
        this.listenerPoint = opts.listenerPoint.geometry;
      }

      var newVolume = this.calculateVolume();
      if (isPlaying === false) this.player.pause();

      if (newVolume < 0.05 && this.player.playing) {
        // allow to fade before pausing
        this.player.fadeOutAndPause();
      } else if (isPlaying === true && newVolume > 0.05) {
        this.play();
      } else this.pause();
    }
    /**
     * Updates / (Schedules a update to if not playing) volume to match speaker track configurations using the `fade()` function
     * @memberof SpeakerTrack
     */

  }, {
    key: "updateVolume",
    value: function updateVolume() {
      var newVolume = this.calculateVolume();
      if (newVolume < 0.05) this.player.fadeOutAndPause();else this.player.fade(newVolume);
      this.currentVolume = newVolume;
      return newVolume;
    }
  }, {
    key: "logline",
    get: function get() {
      return "".concat(this, " (").concat(this.uri, ")");
    }
  }, {
    key: "play",
    value: function play() {
      var _this2 = this;

      var newVolume = this.calculateVolume();
      if (newVolume < 0.05) return; // no need to play

      try {
        this.player.play().then(function (success) {
          if (!success) {
            setTimeout(function () {
              _this2.play();
            }, 1000);
          }
        });
      } catch (err) {
        console.error("Unable to play", this.logline, err);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      try {
        if (this.player.playing) {
          var _this$player;

          (_this$player = this.player) === null || _this$player === void 0 ? void 0 : _this$player.pause();
          (0, _utils.speakerLog)("".concat(this.speakerId, ": Paused!"));
        }
      } catch (err) {
        console.error("Unable to pause", this.logline, err);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      var speakerId = this.speakerId;
      return "SpeakerTrack (".concat(speakerId, ")");
    }
  }]);

  return SpeakerTrack;
}();

exports.SpeakerTrack = SpeakerTrack;